export default __webpack_public_path__ + "static/media/apple-tv-border.5f95bc54.png";